import { FC, useContext, useState } from "react"

import Modal from "../modal";
import { StatisticsObjectType } from "./types";
import { NewPracticeProps } from "src/pages/manufacturer/types";
import { useLocation } from "react-router-dom";
import CopayEnrollmnetModal from "../copayEnrollmentModal";
import { AuthContext } from "src/context/authContext";


const CustomButtonRight: FC<StatisticsObjectType> = ({ StatisticsObjectType, startDate, endDate, showpractice, drug }): JSX.Element => {
    const [showingModal, setModal] = useState(false);
    const [showingCopayModal, setCopayModal] = useState(false);
    const { userData } = useContext(AuthContext);

    const [title, setTitle] = useState("");
    const { pathname } = useLocation()

    const openModal = (title: string) => {
        setTitle(title);
        setModal(true);
        document.body.style.overflow = 'hidden';
    };
    const openCopayModal = () => {
        setTitle(title);
        setCopayModal(true);
        document.body.style.overflow = 'hidden';
    };

    return (
        <>
            {pathname.toLowerCase().includes("statis") && userData?.ref_type?.toLowerCase() === "manufacturer" ? (
                <div className="col d-flex">
                    <div className="card d-flex flex-fill flex-row border-0 bg-purple" data-bs-toggle="tooltip" data-bs-placement="right"
                        title={
                            StatisticsObjectType && StatisticsObjectType.outside_72hr
                                ? StatisticsObjectType.outside_72hr.cases_id.map(item => item).join(", ")
                                : "No cases available"
                        }
                    >
                        <div
                            className="card-header d-flex justify-content-center align-items-center border-0 bg-transparent">
                            <i className="bi bi-folder-fill d-flex justify-content-center align-items-center"></i>
                            <p className="mb-0 text-white fs-5">Outside 24Hr</p>
                        </div>
                        <div className="card-body col d-flex justify-content-end align-items-center">
                            <h1 className="value m-0">
                                {StatisticsObjectType ? StatisticsObjectType.outside_72hr.total_count : 0}
                            </h1>
                        </div>
                    </div>
                </div>
            ) : null}
            <div className="col d-flex">
                <div className="card d-flex flex-fill flex-row border-0 bg-iovera">
                    <div className="card-header pe-0 d-flex justify-content-center align-items-center border-0 bg-transparent">
                        <i className="bi bi-clock-history d-flex justify-content-center align-items-center"></i>
                        <p className="mb-0 fs-5 text-white">Avg TAT</p>
                    </div>
                    <div className="card-body col d-flex justify-content-center align-items-center">
                        <h1 className="value m-0">
                            {StatisticsObjectType ? StatisticsObjectType.avg_tat : "00:00:00"}
                        </h1>
                    </div>
                </div>
            </div>
            {showpractice && <div className="col d-flex">
                <div className="card d-flex flex-fill flex-row border-0 bg-pink">
                    <div
                        className="card-header d-flex justify-content-center align-items-center border-0 bg-transparent">
                        <i className="bi bi-hospital-fill d-flex justify-content-center align-items-center"></i>
                        <p className="mb-0 fs-5 text-white">New Practices</p>
                    </div>
                    <div className="card-body col d-flex justify-content-center align-items-center" onClick={() => { openModal("New Practices") }}>
                        <h1 className="text-link value">
                            {StatisticsObjectType.new_practices.count || 0}
                        </h1>
                    </div>
                </div>
                {showingModal ? <Modal startDate={startDate} endDate={endDate} title={title} data={(StatisticsObjectType && StatisticsObjectType.new_practices as NewPracticeProps)} onClick={() => setModal(false)}></Modal> : null}
            </div>}
            {!(userData &&
                ["rep", "regional_manager", "area_manager","district_manager"].includes(userData.ref_type) &&
                userData.is_iovera_user) &&
                <div className="col d-flex copay-counter">
                    <div className="card d-flex flex-fill flex-row border-0 bg-orange">
                        <div
                            className="card-header d-flex justify-content-center align-items-center border-0 bg-transparent">
                            <i className="bi bi-cash-stack d-flex justify-content-center align-items-center"></i>
                            <p className="mb-0 fs-5 text-white">Copay Enrollment</p>
                        </div>
                        <div className="card-body col d-flex justify-content-center align-items-center" onClick={() => { openCopayModal() }}>
                            <h1 className="text-link value m-0">
                                {StatisticsObjectType.copay_enrollment_count || 0}
                            </h1>
                        </div>
                    </div>
                </div>}
            {showingCopayModal ? <CopayEnrollmnetModal startDate={startDate} endDate={endDate} title={'Copay Enrollment'} data={(StatisticsObjectType && StatisticsObjectType.copay_enrollment)} onClick={() => setCopayModal(false)} drug={drug}></CopayEnrollmnetModal> : null}

        </>
    )
}
export default CustomButtonRight;
